/**
 * How old a capture can be and still count as tonight's.
 *
 * A capture nobody managed to flush for half a day is an abandoned experiment
 * or a forgotten tablet, not a table being served. Fiscal billing is
 * online-only, so real service never runs offline that long.
 */
export const STALE_CAPTURE_MAX_AGE_MS = 12 * 60 * 60 * 1000;

/** Whether an event was made more than half a day ago. */
export function isStaleEvent(event, now = Date.now()) {
  const made = Date.parse(event?.created_at);
  return Number.isFinite(made) && made < now - STALE_CAPTURE_MAX_AGE_MS;
}
